export const buildErrorMessage = (defaultName, error) => {
  if (error.message)
    return error.message

  if (error.type === 'required')
    return `${defaultName} is required`
}
